/**
 * Dynamic delivery messages — calculates the actual delivery day name.
 *
 * Logic:
 *   - Shipping: workdays only (Mon-Fri). Before cutoff = same day, after = next workday. Weekend = Monday.
 *   - Delivery: next workday after shipping. (Fri shipped → Mon delivered, etc.)
 *   - The day name and the word "tomorrow" are rendered in the page's own
 *     language (nl, de, en, fr, ...) via the browser Intl API.
 *
 * Data attributes:
 *   data-delivery-cutoff  — hour (0-23), default 22
 *   data-delivery-before  — template for before cutoff on workdays, with [cutoff] and [dag]
 *   data-delivery-after   — template for after cutoff / weekends, with [dag]
 *
 * Note: keep the literal [cutoff] and [dag] tokens in every translation.
 * They are the placeholders this script fills; the day itself is localized here.
 */
(function () {
  /* Page language, e.g. "nl", "de", "en", "fr". Falls back to Dutch. */
  var LOCALE = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase() || 'nl';

  function localizedDay(date, isTomorrowFlag) {
    try {
      if (isTomorrowFlag) {
        return new Intl.RelativeTimeFormat(LOCALE, { numeric: 'auto' }).format(1, 'day');
      }
      return new Intl.DateTimeFormat(LOCALE, { weekday: 'long' }).format(date);
    } catch (e) {
      /* Older browsers: fall back to a Dutch day name. */
      var DAYS_NL = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
      return isTomorrowFlag ? 'morgen' : DAYS_NL[date.getDay()];
    }
  }

  function nextWorkday(date) {
    var d = new Date(date);
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function isTomorrow(today, target) {
    var tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return target.getDate() === tomorrow.getDate() &&
           target.getMonth() === tomorrow.getMonth() &&
           target.getFullYear() === tomorrow.getFullYear();
  }

  function getDeliveryDay(amsterdam, cutoff) {
    var day = amsterdam.getDay();
    var hour = amsterdam.getHours();
    var isWorkday = day >= 1 && day <= 5;
    var beforeCutoff = hour < cutoff;

    var shipDate;
    if (isWorkday && beforeCutoff) {
      shipDate = new Date(amsterdam);
    } else {
      shipDate = nextWorkday(amsterdam);
      if (!isWorkday) {
        /* Weekend: find Monday */
        shipDate = new Date(amsterdam);
        while (shipDate.getDay() !== 1) {
          shipDate.setDate(shipDate.getDate() + 1);
        }
      }
    }

    return nextWorkday(shipDate);
  }

  function updateDeliveryMessages() {
    var els = document.querySelectorAll('[data-delivery-message]');
    if (!els.length) return;

    var now = new Date();
    var amsterdam = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));

    els.forEach(function (el) {
      var cutoff = parseInt(el.dataset.deliveryCutoff || '22', 10);
      var day = amsterdam.getDay();
      var hour = amsterdam.getHours();
      var isWorkday = day >= 1 && day <= 5;
      var beforeCutoff = hour < cutoff;

      var deliveryDate = getDeliveryDay(amsterdam, cutoff);
      var dayName = localizedDay(deliveryDate, isTomorrow(amsterdam, deliveryDate));

      var template;
      if (isWorkday && beforeCutoff) {
        template = el.dataset.deliveryBefore || 'Voor [cutoff] besteld, [dag] in huis';
      } else {
        template = el.dataset.deliveryAfter || 'Bestel nu, [dag] in huis';
      }

      var msg = template
        .replace(/\[cutoff\]/g, cutoff + ':00')
        .replace(/\[dag\]/g, dayName);

      el.textContent = msg;
      el.style.display = msg ? '' : 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateDeliveryMessages);
  } else {
    updateDeliveryMessages();
  }

  setInterval(updateDeliveryMessages, 60000);
})();
